( function( $ ) {
    'use strict';
    let $article  = jQuery( 'article.main-content' );

    if ( $article && $article.length ){
        const authors     = $article.data( 'authors' ),
            publishDate = $article.data( 'date' ),
            postId      = $( 'article' ).data( 'id' ),
            featured    = $article.data( 'featured' ),
            categories  = $article.data( 'categories' ),
            vertical    = $article.data( 'zone' );

        const articleData = {
            'page': location.pathname,
            'documentTitle': document.title,
            'dimension1': authors,
            'dimension2': publishDate,
            'dimension3': postId,
            'dimension4': 1, 
            'dimension5': featured,
            'dimension6': categories,
            'dimension7': vertical
        };            

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push( articleData );
    }
    
    $( document ).on( 'aw-location-detected', function( ev, locationData ) {
        /* When we detect user location inside plugins/aw-sitewide/global/geoIP.php, pass it to Google Analytics. */

        if ( locationData && locationData.country && locationData.country.iso_code ) {
            const userCountryCode = locationData.country.iso_code;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push( {
                'event': 'country_detected',
                'country': userCountryCode
            } );
        }
    } );
} )( jQuery );
